export enum DatePrecision {
  second = 'SECOND',
  day = 'DAY',
  month = 'MONTH',
  year = 'YEAR',
}